import { locales, defaultLocale } from '../config'
import issueTrackerService from 'services/issueTracker/issueTrackerService'

export const languages = ['fr', 'es']

const LOCALE_TO_LANG = {
  fr: 'fr-FR',
  es: 'es-ES',
}

const LANG_TO_CURRENCY = {
  fr: 'EUR',
  es: 'EUR',
}

export const getCurrencyFromLang = lang => LANG_TO_CURRENCY[lang]

export const getLocaleFromLang = lang => LOCALE_TO_LANG[lang]

export const getLangFromHostname = hostname => {
  if (hostname.match(/\bes\b/)) {
    return 'es'
  }

  return 'fr'
}

export const getLocaleFromHostname = hostname =>
  getLocaleFromLang(getLangFromHostname(hostname))
const getCurrentHostname = () =>
  typeof window === 'undefined' ? undefined : window.location.hostname
export const getUrlFromLocale = (locale, hostname = getCurrentHostname()) => {
  const urls = locales[locale].url.split('|')
  const matchingUrl = urls.find(url => new URL(url).hostname === hostname)

  if (matchingUrl) {
    return matchingUrl
  }

  issueTrackerService.captureError(
    new Error(
      `No URL found for locale "${locale}" and hostname "${hostname}". Falling back to "${urls[0]}".`,
    ),
  )

  return urls[0]
}
export const getProUrlFromLocale = (locale, hostname = getCurrentHostname()) =>
  locales[locale].pro.urls.home.startsWith('http')
    ? locales[locale].pro.urls.home
    : getUrlFromLocale(locale, hostname) + locales[locale].pro.urls.home
export const getLangFromLocale = locale => locale.split('-')[0]
export const getCountryFromLocale = locale => locale.split('-')[1]
export const getDefaultCountry = () => {
  const locale = global.window
    ? getLocaleFromHostname(window.location.hostname)
    : defaultLocale

  return getCountryFromLocale(locale)
}
